import { MdAnnouncement } from "react-icons/md";
import Modal from "react-responsive-modal";

import {Content,
        ButtonsContainer,
        ConfirmButton,
        CancelButton} from './styles';

interface IModalConfirmRemoveProperty{
    open: boolean;
    isLoading: boolean;
    message?: string;
    functionToRemoveProperty(): void;
    functionToCloseModal(): void;
}

export default function ModalConfirmRemoveProperty({
    open,
    isLoading,
    message = "Tem certeza que deseja deletar esse imóvel?",
    functionToRemoveProperty,
    functionToCloseModal,
}: IModalConfirmRemoveProperty){
    return(
        <Modal open={open} onClose={functionToCloseModal} classNames={{
            modal: "remove-photo-modal"
        }}>
            <Content>
                <MdAnnouncement size={40} color="#666666"/>

                <p>{message}</p>

                <ButtonsContainer>
                    <ConfirmButton onClick={!!isLoading ? () => {} : functionToRemoveProperty} isLoading={isLoading}>{!!isLoading ? "Carregando..." : "Sim"}</ConfirmButton>
                    <CancelButton onClick={functionToCloseModal}>Não</CancelButton>
                </ButtonsContainer>
            </Content>
        </Modal>
    );
}